$(function() {

  $('.js-filters').addClass('is-hidden');

  $('.l-filters__title').on('click', function() {
    $('.js-filters').toggleClass('is-hidden');
  });

  $('#offers-filters .c-filter').on('change', function() {
    $('#offers-filters').submit();
  });
});